import { HTTP_METHOD } from "../../../helper/constants";
import request from "../../request";

// Access-management service path, relative to the origin root (same host as
// the app), so it works across environments without hardcoding the host.
const ACCESS_MANAGEMENT_BASE = "api/oneappaccess";

const featureApi = {
  // Returns the user's access: { data: { resources: [{ resource_id, ... }],
  // business, category, business_text, category_text } }.
  getAllowedFeatureIds: ({ empId, email }) => {
    const url = `${ACCESS_MANAGEMENT_BASE}/v1/access-management/fetch-access`;
    return request({
      method: HTTP_METHOD.POST,
      url,
      headers: { "Content-Type": "application/json" },
      data: { empId, email },
      responseType: "json",
      useBaseUrl2: true,
    });
  },
};

export default featureApi;
